import { IState } from '../../store';

export const selectBuyAnalyticsButtonEnabled = (state: IState) => state.featureToggle.isBuyAnalyticsButtonEnabled;
